import { render } from "./Road.vue?vue&type=template&id=af5ea744"
import script from "./Road.vue?vue&type=script&lang=js"
export * from "./Road.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/lotties/Road.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "af5ea744"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('af5ea744', __exports__)) {
    api.reload('af5ea744', __exports__)
  }
  
  module.hot.accept("./Road.vue?vue&type=template&id=af5ea744", () => {
    api.rerender('af5ea744', render)
  })

}


export default __exports__